import React from "react";
import RangeSlider from "react-bootstrap-range-slider";
// import 'bootstrap/dist/css/bootstrap.css'; // or include from a CDN
import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";

const InputRangeSlider = (props) => {
  return (
    <>
      <RangeSlider
        className={props.className}
        max={props.maxValue}
        min={props.minValue}
        value={props.value}
        onChange={(e) => props.setRangeValue(e.target.value)}
        step={props.step}
        tooltip="on"
        tooltipPlacement="bottom"
        tooltipLabel={(currentValue) => `${currentValue}`}
        variant="primary"
      />
      <div className="d-flex justify-content-between">
        <p>{props.minValue}</p>
        <p>{props.maxValue}</p>
      </div>
    </>
  );
};

export default InputRangeSlider;
